import { http } from "@/api/common";

export default {
  async fetch(idToken) {
    return http.get(`/groups`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async create(idToken, payload) {
    return http.post(`/groups`, payload, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async changeSettings(idToken, groupId, payload) {
    return http.post(`/groups/${groupId}/settings`, payload, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async delete(idToken, groupId) {
    return http.delete(`/groups/${groupId}`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async addGroupOrMember(idToken, isGroup, groupId, payload) {
    return http.post(`/groups/${groupId}/members?group=${isGroup}`, payload, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },

  async removeGroupMember(idToken, groupId, memberId) {
    return http.delete(`/groups/${groupId}/members/${memberId}`, undefined, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  },
};
